export default __webpack_public_path__ + "static/media/avatar.b06e1b7d.svg";